import BookingCollectionFilter from './BookingCollectionFilter';

export default BookingCollectionFilter;
